var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsNotEmpty, IsEmail, IsOptional, IsString, MinLength, } from 'class-validator';
export var ContactReason;
(function (ContactReason) {
    ContactReason[ContactReason["GENERAL_HINT"] = 1] = "GENERAL_HINT";
    ContactReason[ContactReason["REPORT_ABUSE"] = 2] = "REPORT_ABUSE";
    ContactReason[ContactReason["SUGGEST_IMPROVEMENT"] = 3] = "SUGGEST_IMPROVEMENT";
})(ContactReason || (ContactReason = {}));
var ContactDto = /** @class */ (function () {
    function ContactDto(contact) {
        this.firstName = contact === null || contact === void 0 ? void 0 : contact.first_name;
        this.lastName = contact === null || contact === void 0 ? void 0 : contact.last_name;
        this.email = contact === null || contact === void 0 ? void 0 : contact.email;
        this.reason = contact === null || contact === void 0 ? void 0 : contact.reason;
        this.message = contact === null || contact === void 0 ? void 0 : contact.message;
    }
    ContactDto.prototype.toRestModel = function () {
        return {
            first_name: this.firstName,
            last_name: this.lastName,
            email: this.email,
            reason: this.reason,
            message: this.message,
        };
    };
    __decorate([
        IsNotEmpty(),
        IsString(),
        __metadata("design:type", String)
    ], ContactDto.prototype, "firstName", void 0);
    __decorate([
        IsNotEmpty(),
        IsString(),
        __metadata("design:type", String)
    ], ContactDto.prototype, "lastName", void 0);
    __decorate([
        IsEmail(),
        IsOptional(),
        __metadata("design:type", String)
    ], ContactDto.prototype, "email", void 0);
    __decorate([
        IsNotEmpty(),
        IsEnum(ContactReason),
        __metadata("design:type", Number)
    ], ContactDto.prototype, "reason", void 0);
    __decorate([
        IsNotEmpty(),
        IsString(),
        MinLength(50),
        __metadata("design:type", String)
    ], ContactDto.prototype, "message", void 0);
    return ContactDto;
}());
export { ContactDto };
